<template>
  <div
    class="moow-master-container play-background"
    v-loading.fullscreen="loading"
    element-loading-text="Saving Data ..."
    element-loading-spinner="el-icon-loading"
  >
    <nav-basic :progress="20" title></nav-basic>
    <div class="container">
      <b-row>
        <p class="moow-header">What kind of place do you have?</p>
      </b-row>
      <b-row>
        <b-col md="6" class="pt-2">
          <b-form @submit="next" class="form-container">
            <md-card class="island-card pr-3">
              <md-card-content>
                <b-row class="first-form-row">
                  <b-col class="text-right">
                    <p class="input-header">Property Type</p>
                    <b-form-select
                      class="moow-input"
                      id="bFormPropertyType"
                      v-model="genDet.propType.superType"
                      required
                      :options="propertyType"
                    ></b-form-select>
                  </b-col>
                </b-row>
                <hr class="hr-form-el-separator" />
                <b-row>
                  <b-col class="text-right">
                    <p class="input-header">Sub Type</p>
                    <b-form-select
                      class="moow-input"
                      v-if="genDet.propType.superType=='apartment'"
                      v-model="genDet.propType.subType"
                      required
                      :options="subPropertyTypeListApartment"
                    ></b-form-select>
                    <b-form-select
                      class="moow-input"
                      v-if="genDet.propType.superType=='house'"
                      v-model="genDet.propType.subType"
                      required
                      :options="subPropertyTypeListHouse"
                    ></b-form-select>
                    <b-form-select
                      class="moow-input"
                      v-if="genDet.propType.superType=='land'"
                      v-model="genDet.propType.subType"
                      required
                      :options="subPropertyTypeListLand"
                    ></b-form-select>
                    <b-form-select
                      class="moow-input"
                      v-if="genDet.propType.superType=='parking'"
                      v-model="genDet.propType.subType"
                      required
                      :options="subPropertyTypeListParking"
                    ></b-form-select>
                    <b-form-select
                      class="moow-input"
                      v-if="genDet.propType.superType=='commercial'"
                      v-model="genDet.propType.subType"
                      required
                      :options="subPropertyTypeListCommercial"
                    ></b-form-select>
                  </b-col>
                </b-row>
              </md-card-content>
            </md-card>

            <b-row class="step-navigator-buttons">
              <b-col style="text-align:left;padding:0">
                <md-button @click="prev()" class="md-primary">
                  <md-icon>arrow_back</md-icon>Back
                </md-button>
              </b-col>
              <b-col style="text-align:right;padding:0">
                <md-button type="submit" class="md-primary play-cta-button makeup">Next</md-button>
              </b-col>
            </b-row>
            
          </b-form>
        </b-col>
        <b-col md="5" offset-md="1">
          <md-card class="island-card">
            <md-card-header>
              <div class="moow-subheader">What each type means?</div>
            </md-card-header>

            <md-card-content>
              <span>
                <b>Apartment</b>
                <p>An apartment, flat or unit is a self-contained housing unit (a type of residential real estate) that occupies only part of a building, generally on a single storey.</p>

                <b>Studio</b>
                <p>A studio apartment, also known as a studio flat, a self-contained apartment, efficiency apartment or bachelor apartment, is a small apartment which combines living room, bedroom, and kitchen into a single room.</p>

                <b>Penthouse</b>
                <p>A penthouse is an apartment located on the top floor of a high-rise apartment building.</p>

                <b>Scole</b>
                <p>A socle is an apartment located on the basement level.</p>

                <b>House</b>
                <p>A house is a separate building that functions as a home.</p>
              </span>
            </md-card-content>
          </md-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
// import {
//   propertyTypeList,
//   parkingPlacementList,
//   subPropertyTypeListApartment,
//   subPropertyTypeListHouse,
//   subPropertyTypeListCommercial,
//   subPropertyTypeListParking,
//   subPropertyTypeListLand
// } from "../lists.js";
  const lists = require('@/lists.js');

import { updateListingParts } from "../listingFunctions.js";
import axios from "axios";
export default {
  name: "basic2",
  data() {
    return {
      loading: false,
      subPropertyTypeListApartment: lists.subPropertyTypeListApartment,
      subPropertyTypeListHouse: lists.subPropertyTypeListHouse,
      subPropertyTypeListCommercial: lists.subPropertyTypeListCommercial,
      subPropertyTypeListLand: lists.subPropertyTypeListLand,
      subPropertyTypeListParking: lists.subPropertyTypeListParking,
      propertyType: lists.propertyTypeList,
      parkingPlacement: lists.parkingPlacementList
    };
  },
  created() {
    this.genDet.propType.superType = "apartment";
    if (!this.$store.getters.basic2Visited) {
      this.populateFieldsFromEhrData(
        JSON.parse(sessionStorage.getItem("buildingServiceData"))
      );
    }
    // else the computed properties are used without any alteration from ehr data
  },
  computed: {
    techDet() {
      return this.$store.getters.techDet;
    },
    genDet() {
      return this.$store.getters.genDet;
    }
  },
  methods: {
    populateFieldsFromEhrData(bData) {
      this.setPropertyTypes(bData);
    },
    setPropertyTypes(bData) {
      if (bData && bData.parts && bData.parts[0] && bData.parts[0].partType) {
        if (bData.parts[0].partType == "apartment") {
          this.genDet.propType.superType = "apartment";
        } else if (bData.parts[0].partType == "housePart") {
          this.genDet.propType.superType = "house";
        } else {
          this.genDet.propType.superType = "commercial";
        }
      }
    },
    leavePage(from, to) {
      this.$store.dispatch("visitPage", from);
      this.$router.push({
        name: to
      });
    },
    notifyError(title, msg) {
      this.$notify({
        title: title,
        message: msg
      });
    },
    next(evt) {
      evt.preventDefault();
      this.save();
      this.leavePage("BASIC2", "basic3");
    },
    prev() {
      this.$store.commit("UPDATE_TECHDET", this.techDet);
      this.$store.commit("UPDATE_GENDET", this.genDet);
      this.leavePage("BASIC2", "adr");
    },
    saveAndExit() {
      this.save();
      this.leavePage("BASIC2", "dashboard");
    },
    save() {
      this.$store.commit("UPDATE_GENDET", this.genDet);
      this.$store.commit("UPDATE_TECHDET", this.techDet);
      updateListingParts(this.createUpdateParts()).catch(err => {});
    },
    createUpdateParts() {
      return {
        genDet: this.genDet,
        techDet: this.techDet
      };
    }
  }
};
</script>

<!-- Add "scoped" attribute to limitss CSS to this component only -->
<style scoped>
@import "../assets/styles/add-steps.css";
@import "../assets/styles/global.css";

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

.button {
  margin-top: 30px;
  width: 150px;
  height: 100px;
  color: #1f8efa;
  border-radius: 4px;
  border: solid 1px #1f8efa;
  background-color: #ffffff;
}

.form-group {
  margin-bottom: 0px;
}

p {
  color: #757575;
  text-align: left;
  font-size: 14px;
}

#desc {
  text-align: left;
  background-color: #fafafa;
  border: solid 1px #d8d8d8;
  overflow: scroll;
  max-height: 464px;
}

#radios1 .custom-control {
  display: block;
  margin-right: 1rem;
  margin-bottom: 0.51em;
}
</style>



// WEBPACK FOOTER //
// src/components/basic2.vue